import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import TinyInputStore from '../../components/tiny-input/store';
import { autobind } from 'core-decorators';
import lockAsync from '../../utils/lock-async';
import captchaHandlerDecorate from '../../utils/captcha-deco-util';
import { message } from 'antd';
import { useRequest } from 'ahooks';
import { useMount } from 'ahooks';
import request from '@src/utils/request';
import * as commonRegex from '../../utils/common-regex';
class VerifyModalStore extends BaseModalStore {
  @observable phoneError = true;
  @observable expandVideoUrl = '';
  @observable closeCallback = noop;

  /**
   * 手机号码输入框
   * @type {*}
   */
  phoneInputStore = new TinyInputStore();

  /**
   * 验证码输入框
   * @type {TinyInputStore}
   */
  smsInputStore = new TinyInputStore();

  @observable captcha_id = '';

  @observable phoneError = false;
  @observable codeError = false;

  /**
   * 发送验证码
   * @param authParams
   * @returns {Promise<boolean>}
   */
  @autobind
  @lockAsync()
  @captchaHandlerDecorate('xoyo')
  async onSendVCRequest({ ...authParams }) {
    try {
      await this.sendCodeRequest.run({ ...authParams });
      message.success('验证码已发送, 请注意查收');
      return true;
    } catch (err) {
      message.error(err.msg);
      return false;
    }
  }

  // sendCodeAsync(params) {
  //   return this.$ztService.getPhoneCode({ ...params });
  // }

  sendCodeAsync(params) {
    // console.log(params);
    // let temp = params;
    // temp.captcha_id = this.captcha_id;

    let { phone, ...otherParams } = params;
    // console.log(phone, otherParams);
    delete otherParams.captcha_id;
    return request.post('api/ssg_recruiting_cn/v1/biz/get_phone_code', { phone, send_code: otherParams });

    // return request.post('https://test-ssg-recruiting-api.seasungames.cn/api/ssg_recruiting_cn/v1/biz/get_phone_code', { ...params });
    // .then(res => {
    //   console.log(res);
    // })
    // .catch(error => {
    //   console.error('GET 请求失败', error);
    // });
  }

  getConfig() {
    return request
      .get('api/ssg_recruiting_cn/v1/biz/get_config', {})
      .then(res => {
        // console.log(res);
        this.captcha_id = res.data.captcha_id;
        window.captcha_id = this.captcha_id;
      })
      .catch(error => {
        console.error('GET 请求失败', error);
      });
  }

  loginPhoneCode(phone, code) {
    return request
      .post('api/ssg_recruiting_cn/v1/biz/login_by_phone_and_code', {
        phone,
        code
      })
      .then(res => {
        // console.log(res);

        this.successCallback();
        this.onClickClose();
      })
      .catch(error => {
        // console.error('GET 请求失败', error);
        if (error.code === 10011) {
          this.codeError = true;
        } else {
          message.error(error.msg);
        }
      });
  }

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  onClickConfirm = () => {
    let phone = this.phoneInputStore.value;
    let code = this.smsInputStore.value;
    if (!phone) {
      this.phoneError = true;
      return;
    } else if (!commonRegex.phoneNumber.test(phone)) {
      this.phoneError = true;
      return;
    } else if (!code) {
      this.codeError = true;
      return;
    }
    this.loginPhoneCode(phone, code);
  };
  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };

  use() {
    /**
     * 获取验证码接口
     */
    this.sendCodeRequest = useRequest(async params => await this.sendCodeAsync(params), { manual: true, throwOnError: true });
    super.use();
    useMount(() => {
      this.getConfig();
    });
  }
}

export default VerifyModalStore;
